import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-39feb700"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "score"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "203px"
  }
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_5 = {
  class: "table"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "录取分析")], -1));
const _hoisted_7 = {
  class: "mohu",
  style: {
    "padding": "20px"
  }
};
const _hoisted_8 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
const _hoisted_10 = {
  class: "con"
};
const _hoisted_11 = {
  "element-loading-text": "数据加载中...",
  style: {
    "margin-top": "30px"
  }
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "复试分析")], -1));
const _hoisted_13 = {
  class: "mohu",
  style: {
    "padding": "20px"
  }
};
const _hoisted_14 = {
  class: "text"
};
const _hoisted_15 = {
  class: "proportion"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1));
const _hoisted_17 = {
  key: 0,
  class: "mohu-filter"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "解锁", -1));
import { Bell } from "@element-plus/icons-vue";
import * as Echarts from "echarts";
import { onMounted, ref } from "vue";
import { scoreAnalysis, fuluStudentAnalysis } from "@/api/api";
import { decrypt } from "@/utils/parseDate";
import { ElMessage, ElMessageBox } from "element-plus";
import "element-plus/theme-chalk/el-message-box.css";
import { useStore } from "vuex";
export default {
  __name: 'Score',
  props: {
    majorId: String
  },
  emits: ["onChange"],
  setup(__props, {
    expose: __expose,
    emit
  }) {
    const props = __props;
    const store = useStore();
    // 点击解锁
    function onUnlock() {
      emit("onChange", {
        isUnlock: true
      });
    }

    // 数据加载中
    const loading = ref(false);
    const chartArray = ref([]);
    const chartObj = ref({});
    const selectYear = ref("");
    const yearOptions = ref([]);
    const tableData = ref([]);
    const formDataList = ref([]);
    const formData = ref({});
    // 所有数据
    const allData = ref([]);
    // 将 myMethod 暴露给父组件
    __expose({
      childMethod
    });
    function childMethod() {
      getScoreAnalysis();
    }
    onMounted(() => {
      getScoreAnalysis();
    });
    function onProportion() {
      ElMessageBox.confirm("复录比=已知复试人数/录取名单人数。部分学校的调剂录取名单可能没有统计在复试名单中，所以部分学校复录比可能小于1", {
        confirmButtonText: "确定",
        title: "提示",
        type: "warning",
        center: true,
        closeOnClickModal: false
      }).then(() => {}).catch(() => {});
    }
    // 是否显示模糊效果
    const isUnlock = ref(false);
    async function getFuluStudentAnalysis() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await fuluStudentAnalysis(data);
        const res = JSON.parse(decrypt(result));
        console.log(res, 9);
        if (res.status === 0 && res.result.length > 0) {
          formDataList.value = res.result;
          formData.value = res.result.filter(ele => ele.year == selectYear.value)[0];
          loading.value = false;
        } else {}
      } catch (error) {
        // throw new Error(error)
      }
    }
    // 获取分数分析数据
    async function getScoreAnalysis() {
      try {
        loading.value = true;
        const data = {
          majorOutRelationId: props.majorId
        };
        const result = await scoreAnalysis(data);
        const res = JSON.parse(decrypt(result));
        console.log(res);
        if (res.status == 8) {
          store.commit("setTipsDialog", true);
        }
        if (res.status == 9) {
          store.commit("setNumberDialog", true);
        }
        if (res.status == 666) {
          ElMessage({
            message: res.msg,
            type: "warning",
            showClose: true
          });
          isUnlock.value = true;
          emit("onChange", {
            isUnlock: true
          });
          tableData.value = [{
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }, {
            yzylqrs: "请解锁查看",
            tjrs: "请解锁查看",
            lqzdf: "请解锁查看",
            lqzgf: "请解锁查看",
            jyfs: "请解锁查看"
          }];
          loading.value = false;
        }
        if (res.status === 0 && res.result.length > 0) {
          const yearList = [...new Set(res.result.map(ele => ele.ssnf))];
          yearOptions.value = yearList.reverse();
          allData.value = res.result;
          console.log(yearOptions.value);
          let lists = res.result.sort(mysort("ssnf"));
          for (let index = 0; index < lists.length; index++) {
            const item = lists[index];
            let zdf = Number(item.lqzdf);
            let zgf = Number(item.lqzgf);
            let jyf = Number(item.jyfs);
            if (item.yzylqrs > 0 || item.tjrs > 0 || zdf > 0 || zgf > 0 || jyf > 0) {
              selectYear.value = item.ssnf;
              break;
            } else {
              selectYear.value = yearList[0];
            }
          }
          console.log(selectYear.value, '年份');
          tableData.value = res.result.filter(ele => ele.ssnf == selectYear.value);
          loading.value = false;
          isUnlock.value = false;
          getFuluStudentAnalysis();
        } else {
          tableData = [];
          allData = [];
          selectYear.value = "";
          yearOptions.value = [];
          loading.value = false;
        }
        // if(res.status === 0 && res.result.length>0){
        // 	isUnlock.value = false;
        // 	chartArray.value = res.result.reverse()
        // 	const yearList = [...new Set(chartArray.value.map(ele=>ele.ssnf))]
        //   yearOptions.value = yearList
        // 	chartObj.value = chartArray.value[0]
        // 	selectYear.value = chartObj.value.ssnf
        // 	initCharts(chartObj.value)
        // } else {
        // 	// defaultYear.value = new Date()
        // 	chartArray.value = []
        // 	chartObj.value = {
        // 		yzylqrs:0,
        // 		tjrs: 0,
        // 		lqzdf: 0,
        // 		lqzgf: 0,
        // 		jyfs: 0
        // 	}
        // 	initCharts(chartObj.value)
        // }
        // if (res.status == 666) {
        // 	ElMessage({
        //     message: res.msg,
        //     type: "warning",
        //     showClose: true,
        //   });
        // 	isUnlock.value = true;
        //   emit("onChange", { isUnlock: true });
        // 	chartArray.value = []
        // 	chartObj.value = {
        // 		yzylqrs: 20,
        // 		tjrs: 20,
        // 		lqzdf: 20,
        // 		lqzgf: 20,
        // 		jyfs: 20
        // 	}
        // 	initCharts(chartObj.value)
        // }
        // loading.value = false
      } catch (error) {
        loading.value = false;
        // throw new Error(error)
      }
    }

    function mysort(i) {
      return function (a, b) {
        return b[i] - a[i];
      };
    }
    // 改变年份
    function yearChange(val) {
      selectYear.value = val;
      const res = allData.value.filter(ele => ele.ssnf == val);
      tableData.value = res;
      formData.value = formDataList.value.filter(ele => ele.year == val)[0];
      // loading.value = true
      // if(!val){
      // 	chartObj.value = chartArray.value[0]
      // 	selectYear.value = new Date(chartObj.value.ssnf)
      //   initCharts(chartObj.value)
      // 	return
      // }
      // const find = chartArray.value.find(ele=>ele.ssnf === val)
      // if(find){
      // 	initCharts(find)
      // } else {
      // 	initCharts({
      // 		yzylqrs:0,
      // 		tjrs: 0,
      // 		lqzdf: 0,
      // 		lqzgf: 0,
      // 		jyfs: 0
      // 	})
      // }
      // loading.value = false
    }
    // 初始化图表
    function initCharts(obj) {
      const myChart = Echarts.init(document.querySelector(".charts"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        xAxis: {
          data: ["一志愿人数", "调剂人数", "最低分", "最高分", "建议分"]
        },
        yAxis: {
          minInterval: 1
        },
        series: [{
          type: "bar",
          data: [obj.yzylqrs, obj.tjrs, obj.lqzdf, obj.lqzgf, obj.jyfs]
        }]
      });
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Key = _resolveComponent("Key");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_card = _resolveComponent("el-card");
      const _component_QuestionFilled = _resolveComponent("QuestionFilled");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _hoisted_4, _createVNode(_component_el_select, {
        modelValue: selectYear.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectYear.value = $event),
        placeholder: "选择年份",
        onChange: yearChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, ele => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: ele,
            value: ele,
            key: ele
          }, null, 8, ["label", "value"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_card, {
        shadow: "hover"
      }, {
        header: _withCtx(() => [_hoisted_6]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          stripe: "",
          "element-loading-text": "数据加载中...",
          "empty-text": "暂无数据，请重新选择条件查询",
          data: tableData.value,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "yzylqrs",
            label: "一志愿人数"
          }), _createVNode(_component_el_table_column, {
            prop: "tjrs",
            label: "调剂人数"
          }), _createVNode(_component_el_table_column, {
            prop: "lqzdf",
            label: "最低分（排除专项计划）"
          }), _createVNode(_component_el_table_column, {
            prop: "lqzgf",
            label: "最高分"
          }), _createVNode(_component_el_table_column, {
            prop: "jyfs",
            label: "建议分"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_el_button, {
          type: "success",
          onClick: onUnlock
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_Key)]),
            _: 1
          }), _hoisted_9]),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        _: 1
      })]), _createElementVNode("div", _hoisted_10, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_card, {
        shadow: "hover"
      }, {
        header: _withCtx(() => [_hoisted_12]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", null, " 复录比为" + _toDisplayString(formData.value.fuluRaio == null ? 0 : formData.value.fuluRaio) + "。 ", 1), _createVNode(_component_el_icon, {
          class: "proportion-icon",
          size: "22px",
          onClick: onProportion,
          color: "#F56C6C"
        }, {
          default: _withCtx(() => [_createVNode(_component_QuestionFilled)]),
          _: 1
        })]), _hoisted_16, _createTextVNode(" 进复试最低分 " + _toDisplayString(formData.value.fuLowScore == null ? 0 : formData.value.fuLowScore) + "，进复试最高分 " + _toDisplayString(formData.value.fuHighScore == null ? 0 : formData.value.fuHighScore) + "，进复试中位分 " + _toDisplayString(formData.value.fuMedianScore == null ? 0 : formData.value.fuMedianScore) + "。 ", 1)]), isUnlock.value ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_button, {
          type: "success",
          onClick: onUnlock
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-icon--right"
          }, {
            default: _withCtx(() => [_createVNode(_component_Key)]),
            _: 1
          }), _hoisted_18]),
          _: 1
        })])) : _createCommentVNode("", true)])]),
        _: 1
      })])), [[_directive_loading, loading.value]])])]);
    };
  }
};